export const SHOW_LOADER='SHOW_LOADER'
export const SHOW_LINEAR_LOADER='SHOW_LINEAR_LOADER'
export const HIDE_LOADER='HIDE_LOADER'
export const HIDE_LINEAR_LOADER='HIDE_LINEAR_LOADER'